import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FA68ACCA-389F-453E-B886-FF3DAFE10530
 * name crop
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/crop.svg
 * tags
 */
export const CropIcon = createSvgIcon(<><path d="M7,17V1H5V5H1V7H5V17A2,2 0 0,0 7,19H17V23H19V19H23V17M17,15H19V7C19,5.89 18.1,5 17,5H9V7H17V15Z" /></>, 'CropIcon');
export default CropIcon